import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  fetch() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          roles {
            id,
            name,
            display_name
          }
        }
      `
    })
  },
  infos(roleId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          roleInfos (
            id: ${roleId}
          ) {
            id,
            name,
            display_name,
            has_permissions
          }
        }
      `
    })
  },
  add(role) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createRole (
            display_name: "${role.display_name}",
            permissions: [${role.selectedPermissions.join(',')}]
          ) {
            id,
            name,
            display_name
          }
        }
      `
    })
  },
  update(role) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateRole (
            id: ${role.id},
            display_name: "${role.display_name}",
            permissions: [${role.selectedPermissions.join(',')}]
          ) {
            id,
            name,
            display_name
          }
        }
      `
    })
  },
  delete(roleId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteRole (
            id: ${roleId}
          )
        }
      `
    })
  }
}
